export class CollectionGenerateError extends Error {
    constructor(why) {
        super(`Failed to generate game specific data for collection: ${why}`);
        this.name = "CollectionGenerateError";
    }
}
export class CollectionParseError extends Error {
    mCollection;
    constructor(collection, why) {
        super(`Failed to parse game specific data for collection: ${why}`);
        this.name = "CollectionGenerateError";
        this.mCollection = collection;
    }
    get collectionName() {
        return this.mCollection.info.name;
    }
}
